import type { NotificationSeverity } from '@devrobot/shared';
import { AlertTriangle, Info, OctagonAlert } from 'lucide-react';
import type { ComponentType } from 'react';

/**
 * Severity always travels as an icon plus a word, never colour alone: the house rule for
 * status in this app, and the only way the inbox reads correctly to someone colour-blind.
 */
export const SEVERITY: Record<NotificationSeverity, { label: string; icon: ComponentType<{ className?: string }>; tint: string; ink: string; badge: string }> = {
  critical: { label: 'Critical', icon: OctagonAlert, tint: 'dr-tint-error', ink: 'dr-ink-error', badge: 'badge-error' },
  warning: { label: 'Warning', icon: AlertTriangle, tint: 'dr-tint-warning', ink: 'dr-ink-warning', badge: 'badge-warning' },
  info: { label: 'Info', icon: Info, tint: 'dr-tint-info', ink: 'dr-ink-info', badge: 'badge-info' },
};
